import { z } from "zod";

// Mensajes literales de SPEC-205 §7: el servidor devuelve el mismo código si
// el cliente saltea esta validación (mismo criterio que
// `FIELDS_REQUIRED_MESSAGE` en offers/offerSchemas.ts).
export const IMAGE_REQUIRED_MESSAGE =
  "La pantalla de bienvenida requiere una imagen principal";

export const CHIP_INCOMPLETE_MESSAGE =
  "Cada chip requiere ícono, título y descripción";

// SPEC-205 §2: "son exactamente tres chips, ni más ni menos" — la pantalla
// no admite una cantidad variable (§9, fuera de alcance).
export const CHIP_COUNT = 3;

const chipFormSchema = z.object({
  icon: z.string().trim().min(1, CHIP_INCOMPLETE_MESSAGE),
  titleEs: z.string().trim().min(1, CHIP_INCOMPLETE_MESSAGE),
  titleEn: z.string(),
  descriptionEs: z.string().trim().min(1, CHIP_INCOMPLETE_MESSAGE),
  descriptionEn: z.string(),
});
export type ChipFormValues = z.infer<typeof chipFormSchema>;

export const welcomeFormSchema = z.object({
  imageUrl: z.string().trim().min(1, IMAGE_REQUIRED_MESSAGE),
  // PLAN-007 Fase 4d: id del archivo ya subido y confirmado
  // (`uploadImage`/`FileUploadChip`), con prioridad sobre `imageUrl` en el
  // servidor (WelcomeInput.imageFileId). Vacío cuando el operador no tocó
  // la imagen en esta sesión del formulario.
  imageFileId: z.string(),
  chips: z.array(chipFormSchema).length(CHIP_COUNT),
});
export type WelcomeFormValues = z.infer<typeof welcomeFormSchema>;
